module.exports = __webpack_public_path__ + "img/newton-3.7bf7f9f7.png";